<script>
  import liberarPagamento from '../servico';
  import Paginacao from '~componentes/Paginacao.vue';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import projetoServico from '~modulos/projeto/servico';
  import DatePicker from 'vue2-datepicker';
  import tipoUsuario from '~js/tipo-usuario';
  import ModalDetalheLancamento from './ModalDetalheLancamento.vue';

  const GRUPO_PENDENTE = 1;
  const GRUPO_REPROVADO = 2;

  const SECOES = {
    1: { label: 'PENDÊNCIAS · AGUARDANDO SUA DECISÃO', classe: 'cabecalho-pendencias' },
    2: { label: 'REPROVADOS · PAGAMENTO BLOQUEADO', classe: 'cabecalho-reprovados' },
    3: { label: 'HISTÓRICO', classe: 'cabecalho-historico' },
  };

  export default {
    name: 'LiberarPagamentoLista',
    components: {
      Paginacao,
      DatePicker,
      ModalDetalheLancamento,
    },
    data() {
      return {
        registros: [],
        resumo: null,
        carregando: false,
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        usaDataPrevisao: false,
        animated: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        filtros: this.filtrosIniciais(),
        projetos: [],
        modalDetalhe: false,
        lancamentoSelecionado: null,
        requisicao: 0,
        temporizadorFiltro: null,
        situacoes: [
          { valor: '1', label: 'Pendentes' },
          { valor: '3', label: 'Reprovados' },
          { valor: '2', label: 'Liberados/pagos' },
          { valor: '0', label: 'Todos' },
        ],
      }
    },
    methods: {
      filtrosIniciais() {
        const filtros = this.camposFiltros();
        const situacao = this.$route.query.situacao;

        if (['0', '1', '2', '3'].includes(situacao)) {
          filtros.situacao = situacao;
        }

        return filtros;
      },
      camposFiltros() {
        return {
          idProjeto: '0',
          idLancamento: '',
          historico: '',
          situacao: '1',
          periodo: '',
        };
      },
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao('LiberarPagamento')
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      resetarPaginacao() {
        if (this.$refs.paginacao) {
          this.$refs.paginacao.selected = 0;
        }
      },
      filtrar() {
        this.resetarPaginacao();
        this.lista(1);
      },
      filtrarDepois(espera) {
        clearTimeout(this.temporizadorFiltro);
        this.temporizadorFiltro = setTimeout(() => this.filtrar(), espera);
      },
      escolherSituacao(valor) {
        this.filtros.situacao = valor;
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val(0).trigger('change.select2');
        });
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      lista(pagina = 1) {
        this.pagina = pagina;
        this.carregando = true;

        const requisicao = ++this.requisicao;

        return liberarPagamento.lista(pagina, this.filtros)
          .then(dados => {
            if (requisicao !== this.requisicao) return;

            this.carregando = false;

            this.registros = dados.registros;
            this.resumo = dados.resumo;
            this.totalRegistros = dados.totalRegistros;
            this.totalPaginas = dados.totalPaginas;
            this.registrosPorPagina = dados.registrosPorPagina;
            this.usaDataPrevisao = !!dados.usaDataPrevisao;

            if (this.registros.length === 0 && this.pagina > 1) {
              this.lista(this.pagina - 1);
            }
          })
          .catch(erro => {
            if (requisicao !== this.requisicao) return;

            this.carregando = false;
            this.$mensagemErro(erro, 'Erro ao carregar a lista.');
          });
      },
      textoAlerta(registro) {
        if (registro.alerta === 1) return 'Atrasado';
        if (registro.diasParaVencer === 0) return 'Vence hoje';
        if (registro.diasParaVencer === 1) return 'Vence amanhã';

        return `Vence em ${registro.diasParaVencer} dias`;
      },
      situacaoLinha(registro) {
        if (registro.pago) return { rotulo: 'Pago', badge: 'label-pago', linha: 'linha-paga' };
        if (registro.grupo === GRUPO_REPROVADO) return { rotulo: 'Reprovado', badge: 'label-reprovado', linha: 'linha-reprovada' };
        if (registro.grupo !== GRUPO_PENDENTE) return { rotulo: 'Liberado', badge: 'label-liberado', linha: 'linha-liberada' };
        if (registro.alerta === 1) return { rotulo: 'Atrasado', badge: 'label-danger', linha: 'danger' };
        if (registro.alerta === 2) return { rotulo: this.textoAlerta(registro), badge: 'label-warning', linha: 'warning' };

        return { rotulo: 'Aguardando', badge: 'label-aguardando', linha: '' };
      },
      textoDecisao(registro) {
        if (registro.grupo === GRUPO_PENDENTE) return '';

        const responsavel = registro.nomeResponsavelDecisao && !registro.pago ? ` por ${registro.nomeResponsavelDecisao}` : '';

        return `${registro.status}${responsavel}`;
      },
      detalhes(registro) {
        this.lancamentoSelecionado = registro.idLancRateioCrypt;
        this.modalDetalhe = true;
      },
      detalheFechado() {
        this.animated = false;
        this.modalDetalhe = false;
        this.lancamentoSelecionado = null;
        $('body').removeClass('modal-open');
      },
      decidido() {
        this.lista(this.pagina);
      },
      gerarExcel() {
        $('#gerar-excel').button('loading');

        return liberarPagamento
          .excel(this.filtros)
          .then(arquivo => {
            $('#gerar-excel').button('reset');

            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório em excel.');
          });
      },
    },

    created() {
      this.lista();
    },

    mounted() {
      this.$root.tituloDaPagina = 'Liberar Pagamento - Lista';
      this.$root.botaoAcaoTexto = '';
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
        .change(function (e) {
          _this.$set(_this.filtros, 'idProjeto', this.value);
        });
    },
    watch: {
      'filtros.idProjeto'() { this.filtrarDepois(0); },
      'filtros.situacao'() { this.filtrarDepois(0); },
      'filtros.periodo'() { this.filtrarDepois(0); },
      'filtros.idLancamento'() { this.filtrarDepois(500); },
      'filtros.historico'() { this.filtrarDepois(500); },
    },
    beforeDestroy() {
      clearTimeout(this.temporizadorFiltro);
    },
    computed: {
      podeLiberarPagamento() {
        const permissoes = (this.usuario && this.usuario.permissoes) || {};

        return this.usuario.tipoUsuario === tipoUsuario.Coordenador && permissoes.liberarPagamento;
      },
      totalColunas() {
        return this.usaDataPrevisao ? 12 : 11;
      },
      classePainel() {
        if (!this.resumo || this.resumo.quantidadePendentes === 0) return 'painel-em-dia';
        if (this.resumo.quantidadeAtrasados > 0) return 'painel-atrasados';

        return 'painel-pendentes';
      },
      textoReprovadosBloqueados() {
        const quantidade = this.resumo ? this.resumo.quantidadeReprovados : 0;

        return quantidade === 1 ? '1 reprovado continua bloqueado.' : `${quantidade} reprovados continuam bloqueados.`;
      },
      detalhePainel() {
        const resumo = this.resumo;
        const partes = [];

        if (!resumo) return '';

        const outros = resumo.quantidadePendentes - resumo.quantidadeAtrasados;

        if (resumo.quantidadeAtrasados > 0 && outros > 0) {
          partes.push(`e mais ${outros} aguardando`);
        }

        if (resumo.quantidadeVencendo > 0) {
          partes.push(resumo.quantidadeVencendo === 1
            ? '1 vence nos próximos dias'
            : `${resumo.quantidadeVencendo} vencem nos próximos dias`);
        }

        if (resumo.quantidadeReprovados > 0) {
          partes.push(resumo.quantidadeReprovados === 1
            ? '1 reprovado'
            : `${resumo.quantidadeReprovados} reprovados`);
        }

        return partes.join(' · ');
      },
      linhas() {
        const itens = [];
        let grupoAtual = null;
        let projetoAtual = null;

        this.registros.forEach(registro => {
          if (registro.grupo !== grupoAtual) {
            const secao = SECOES[registro.grupo] || SECOES[3];
            itens.push({ tipo: 'cabecalho', chave: `c-${registro.grupo}`, label: secao.label, classe: secao.classe });
            grupoAtual = registro.grupo;
            projetoAtual = null;
          }

          if (registro.idProjetoRateio !== projetoAtual) {
            itens.push({ tipo: 'subcabecalho', chave: `s-${registro.grupo}-${registro.idProjetoRateio}`, nomeProjeto: registro.nomeProjeto });
            projetoAtual = registro.idProjetoRateio;
          }

          itens.push({ tipo: 'linha', chave: registro.idLancRateioCrypt, registro, situacao: this.situacaoLinha(registro) });
        });

        return itens;
      },
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">
    <modal-detalhe-lancamento :mostrar="modalDetalhe"
                              :id="lancamentoSelecionado"
                              :pode-liberar="podeLiberarPagamento"
                              @fechado="detalheFechado"
                              @decidido="decidido">
    </modal-detalhe-lancamento>

    <div class="row" v-if="resumo">
      <div class="col-lg-12">
        <div :class="['painel-resumo', classePainel]">
          <div class="row" v-if="resumo.quantidadePendentes > 0">
            <div class="col-sm-7">
              <div class="painel-titulo" v-if="resumo.quantidadeAtrasados > 0">
                <i class="fa fa-exclamation-triangle"></i>
                Você possui <strong>{{ resumo.quantidadeAtrasados }}</strong>
                {{ resumo.quantidadeAtrasados === 1 ? 'pagamento atrasado aguardando sua decisão' : 'pagamentos atrasados aguardando sua decisão' }}
              </div>
              <div class="painel-titulo" v-else>
                <i class="fa fa-clock-o"></i>
                Você possui <strong>{{ resumo.quantidadePendentes }}</strong>
                {{ resumo.quantidadePendentes === 1 ? 'pagamento aguardando sua decisão' : 'pagamentos aguardando sua decisão' }}
              </div>
              <div class="painel-detalhe" v-if="detalhePainel">{{ detalhePainel }}</div>
            </div>
            <div class="col-sm-5 text-right">
              <div class="painel-subtitulo">Total aguardando sua decisão</div>
              <div class="painel-valor">
                <span class="painel-rs">R$</span>
                {{ resumo.valorPendente | formatarNumero }}
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-xs-12">
              <div class="painel-titulo">
                <i class="fa fa-check-circle"></i>
                Nenhum pagamento aguardando sua decisão.
                <span v-if="resumo.quantidadeReprovados > 0" class="painel-complemento">
                  {{ textoReprovadosBloqueados }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-down"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>

              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label block">Período</label>

                  <date-picker v-model="filtros.periodo"
                               input-class="form-control"
                               range
                               :editable="false"
                               lang="pt-br"
                               :confirm="true"
                               range-separator="a"
                               format="DD/MM/YYYY"
                               :shortcuts="false">
                  </date-picker>
                </div>
              </div>

              <div class="col-xs-2">
                <div class="form-group">
                  <label class="control-label" for="idLancamento">ID do lançamento</label>
                  <input id="idLancamento"
                         type="text"
                         class="form-control"
                         v-model="filtros.idLancamento">
                </div>
              </div>

              <div class="col-xs-2">
                <div class="form-group">
                  <label class="control-label" for="historico">Histórico</label>
                  <input id="historico"
                         type="text"
                         class="form-control"
                         v-model="filtros.historico">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                  <button id="gerar-excel"
                          type="button"
                          class="btn btn-primary no-margins"
                          @click="gerarExcel"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
                    <i class="fa fa-table"></i>
                    Gerar listagem em excel
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">
            <div class="barra-situacao">
              <span class="barra-situacao-titulo">Mostrar</span>
              <button v-for="opcao in situacoes"
                      :key="opcao.valor"
                      type="button"
                      :class="['btn', 'btn-situacao', { 'ativa': filtros.situacao === opcao.valor }]"
                      @click="escolherSituacao(opcao.valor)">
                {{ opcao.label }}
                <span v-if="resumo && opcao.valor === '1'" class="badge">{{ resumo.quantidadePendentes }}</span>
                <span v-if="resumo && opcao.valor === '3'" class="badge">{{ resumo.quantidadeReprovados }}</span>
              </button>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered tabela-liberacao">
                <thead>
                  <tr>
                    <th class="text-center">Situação</th>
                    <th>Lançamento</th>
                    <th>Vencimento</th>
                    <th v-if="usaDataPrevisao">Previsão</th>
                    <th>Pagamento</th>
                    <th>Documento</th>
                    <th>Beneficiário</th>
                    <th>Histórico</th>
                    <th>Rubrica</th>
                    <th>Subrubrica</th>
                    <th class="text-right">Valor do rateio</th>
                    <th class="text-center">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in linhas">
                    <tr v-if="item.tipo === 'cabecalho'"
                        :key="item.chave"
                        :class="['linha-separador-secao', item.classe]">
                      <td :colspan="totalColunas">{{ item.label }}</td>
                    </tr>
                    <tr v-else-if="item.tipo === 'subcabecalho'"
                        :key="item.chave"
                        class="linha-subcabecalho">
                      <td :colspan="totalColunas">{{ item.nomeProjeto || '---' }}</td>
                    </tr>
                    <tr v-else
                        :key="item.chave"
                        :class="item.situacao.linha">
                      <td class="text-center">
                        <span :class="['label', 'label-situacao', item.situacao.badge]" v-tooltip="textoDecisao(item.registro)">{{ item.situacao.rotulo }}</span>
                      </td>
                      <td class="coluna-lancamento">{{ item.registro.idLancamento }}</td>
                      <td class="coluna-data">{{ item.registro.dataVencimento | formatarData('---') }}</td>
                      <td class="coluna-data" v-if="usaDataPrevisao">{{ item.registro.dataPrevisao | formatarData('---') }}</td>
                      <td class="coluna-data">{{ item.registro.dataPagamento | formatarData('---') }}</td>
                      <td class="coluna-curta">{{ item.registro.documentoReceberPagar || '---' }}</td>
                      <td>{{ item.registro.beneficiario || '---' }}</td>
                      <td>{{ item.registro.historico || '---' }}</td>
                      <td>{{ item.registro.nomeRubrica || '---' }}</td>
                      <td>{{ item.registro.nomeSubrubrica || '---' }}</td>
                      <td class="text-right valor-rateio">
                        <span class="prefixo-rs">R$</span>
                        {{ item.registro.valor | formatarNumero }}
                      </td>
                      <td class="text-center coluna-acao">
                        <button v-if="item.registro.grupo === 1"
                                type="button"
                                class="btn btn-primary btn-acao"
                                @click="detalhes(item.registro)">
                          <i class="fa fa-gavel"></i> Decidir
                        </button>
                        <button v-else
                                type="button"
                                class="btn btn-default btn-acao"
                                @click="detalhes(item.registro)">
                          <i class="fa fa-search"></i> Visualizar
                        </button>
                      </td>
                    </tr>
                  </template>
                  <tr v-if="registros.length === 0 && !carregando">
                    <td :colspan="totalColunas" class="text-center">Nenhum registro encontrado.</td>
                  </tr>
                  <tr v-show="carregando">
                    <td :colspan="totalColunas" class="text-center linha-carregando">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true"
                       ref="paginacao">
            </paginacao>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .linha-carregando {
    padding: 24px 10px !important;
    color: #5d6062;
  }

  .table td {
    vertical-align: middle;
  }

  .painel-resumo {
    padding: 18px 22px;
    border-radius: 4px;
    margin-bottom: 15px;
    border-left: 5px solid;
  }

  .painel-atrasados {
    background-color: #fdecea;
    border-left-color: #d9534f;
    color: #6b1f1c;
  }

  .painel-pendentes {
    background-color: #fcf8e3;
    border-left-color: #f0ad4e;
    color: #7a5a1b;
  }

  .painel-em-dia {
    background-color: #dff0d8;
    border-left-color: #5cb85c;
    color: #2b542c;
  }

  .painel-titulo {
    font-size: 1.05em;
    line-height: 1.6em;
  }

  .painel-detalhe {
    font-size: 0.9em;
    opacity: 0.85;
    margin-top: 4px;
    margin-left: 22px;
  }

  .painel-complemento {
    margin-left: 6px;
    opacity: 0.85;
  }

  .painel-subtitulo {
    font-size: 0.85em;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    opacity: 0.8;
  }

  .painel-valor {
    font-size: 1.8em;
    font-weight: 700;
    line-height: 1.2em;
  }

  .painel-rs {
    font-weight: 700;
    margin-right: 5px;
  }

  .barra-situacao {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-bottom: 12px;
  }

  .barra-situacao-titulo {
    font-weight: 600;
    margin-right: 6px;
  }

  .btn-situacao {
    height: 34px;
    background: #fff;
    border: 1px solid #c9cdd0;
    color: #4f5254;
  }

  .btn-situacao.ativa {
    background: #2f4050;
    border-color: #2f4050;
    color: #fff;
  }

  .btn-situacao .badge {
    margin-left: 4px;
    background-color: #e4e6e8;
    color: #3d4043;
  }

  .btn-situacao.ativa .badge {
    background-color: #fff;
    color: #2f4050;
  }

  .linha-separador-secao > td {
    font-size: 0.85em;
    font-weight: 700;
    letter-spacing: 1.5px;
    padding: 7px 10px;
    background-color: #f5f5f5;
    border-top: 2px solid #ccc;
    color: #555;
  }

  .linha-separador-secao.cabecalho-pendencias > td {
    background-color: #fdf2f0;
    color: #8a3a3a;
    border-top-color: #d9534f;
  }

  .linha-separador-secao.cabecalho-reprovados > td {
    background-color: #f4f1f8;
    color: #5a3d7a;
    border-top-color: #8e6bb8;
  }

  .linha-separador-secao.cabecalho-historico > td {
    background-color: #f7f7f7;
    color: #777;
  }

  .linha-subcabecalho > td {
    background-color: #fff;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    padding: 5px 10px;
    font-weight: 700;
    color: #2c3e50;
  }

  .label-situacao {
    display: inline-block;
    min-width: 84px;
    padding: 3px 6px;
    font-size: 0.8em;
  }

  .label-aguardando {
    background-color: #e4e6e8;
    color: #3d4043;
  }

  .label-reprovado {
    background-color: #6f4f96;
    color: #fff;
  }

  .label-liberado {
    background-color: #1c84c6;
    color: #fff;
  }

  .label-pago {
    background-color: #3c8d3c;
    color: #fff;
  }

  tr.linha-reprovada > td {
    background-color: #f7f4fa;
  }

  tr.linha-liberada > td {
    background-color: #eef5fb;
  }

  tr.linha-paga > td {
    background-color: #eef7ea;
  }

  .coluna-lancamento {
    font-weight: 600;
    white-space: nowrap;
  }

  .coluna-data {
    white-space: nowrap;
  }

  .coluna-curta {
    white-space: nowrap;
  }

  .valor-rateio {
    font-weight: 700;
    color: #2c3e50;
    white-space: nowrap;
  }

  tr.danger .valor-rateio {
    color: #a94442;
  }

  tr.warning .valor-rateio {
    color: #8a6d3b;
  }

  .prefixo-rs {
    font-weight: 700;
    margin-right: 3px;
  }

  .coluna-acao {
    white-space: nowrap;
  }

  .btn-acao {
    height: 30px;
    width: 100px;
    padding: 4px 6px;
  }

  .tabela-liberacao > tbody > tr > td {
    padding-top: 5px;
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-pagamento/componentes/LiberarPagamentoLista.vue